;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export type NotificationType =
  | 'system'
  | 'employees'
  | 'payroll'
  | 'expenses'
  | 'invoices'
  | 'errors'
  // BE notification_categories.value
  | 'teams'
  | 'team_members'
  | 'organisation'
  | 'settings'
  | 'task'
  | 'kyb'
  | 'msa';

export interface NotificationItem {
  id: number;
  notification_user_id: number;
  type: NotificationType;
  message: string;
  date: string;
  read: boolean;
}

export type NotificationsList = NotificationItem[];
